/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tr_BuilderInputs */

const en_cp_tr_builder = /** @type {(inputs: Cp_Tr_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder — build a business`)
};

const id_cp_tr_builder = /** @type {(inputs: Cp_Tr_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder — bangun bisnis`)
};

/**
* | output |
* | --- |
* | "Builder — build a business" |
*
* @param {Cp_Tr_BuilderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tr_builder = /** @type {((inputs?: Cp_Tr_BuilderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tr_BuilderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tr_builder(inputs)
	return en_cp_tr_builder(inputs)
});